import { StockFilterTypeEnum } from 'global/MainLayout/SideWidget/RunningTrade/types';
import produce from 'immer';
import create from 'zustand';

export type RunningTradeStore = {
  instances: RunningTradeStoreState;

  setActive: (key: RunningTradeKey, value: boolean) => void;
  setStock: (key: RunningTradeKey, value: RunningTradeStockFilter) => void;
  setFilter: (
    key: RunningTradeKey,
    value: Partial<RunningTradeCustomFilter>,
  ) => void;
  setDate: (key: RunningTradeKey, value: moment.Moment | null) => void;
  play: (key: RunningTradeKey) => void;
  pause: (key: RunningTradeKey) => void;
  getSymbols: (key?: RunningTradeKey) => string[];
};
const initialInstance: RunningTradeStoreInstance = {
  stock: { type: StockFilterTypeEnum.AllStock, selected: [] },
  isActive: false,
  isQueue: false,
  isPaused: false,
  filter: null,
  date: null,
};

export const useRunningTradeStore = create<RunningTradeStore>((set, get) => ({
  instances: {
    company: initialInstance,
    widget: {
      ...initialInstance,
      stock: { type: StockFilterTypeEnum.AllStock, selected: ['*'] },
    },
    fastOrder: initialInstance,
  },
  setActive: (key, value) => {
    set((state) =>
      produce(state, (draft) => {
        draft.instances[key].isActive = value;
      }),
    );
  },
  setStock: (key, value) => {
    set((state) =>
      produce(state, (draft) => {
        draft.instances[key].stock = value;
        if (
          value.type === StockFilterTypeEnum.AllStock ||
          value.type === StockFilterTypeEnum.Watchlist ||
          value.selected.length > 1
        ) {
          draft.instances[key].date = null;
        }
        state.play(key);
      }),
    );
  },
  setFilter: (key, value) => {
    set((state) =>
      produce(state, (draft) => {
        draft.instances[key].filter = value;
      }),
    );
  },
  setDate: (key, value) => {
    set((state) =>
      produce(state, (draft) => {
        draft.instances[key].date = value;
      }),
    );
  },
  play: (key) => {
    set((state) =>
      produce(state, (draft) => {
        draft.instances[key].isPaused = false;
      }),
    );
  },
  pause: (key) => {
    set((state) =>
      produce(state, (draft) => {
        draft.instances[key].isPaused = true;
      }),
    );
  },
  getSymbols: (key) => {
    const { instances } = get();
    if (key) return instances[key]?.stock?.selected || [];

    let allSymbols: string[] = [];
    Object.values(instances).forEach((instance) => {
      if (!instance.isActive) return;

      const symbols = instance.stock?.selected || [];
      allSymbols = [...allSymbols, ...symbols];
    });
    return Array.from(new Set(allSymbols));
  },
}));
